export { IconAroundVehicle } from './IconAroundVehicle';
export { type IconAroundVehicleProps } from './IconAroundVehicle.types';
